import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AccordionModule} from 'primeng/accordion';
import { TableModule} from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ConfirmationService} from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessagesModule } from 'primeng/messages';
import { CalendarModule } from 'primeng/calendar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ChartModule } from 'primeng/chart';

//
import { CaseListComponent } from 'src/app/reports/case-list.component';
import { ExpirationListComponent } from 'src/app/reports/expiration-list.component';
import { LoginRouteGuard } from 'src/app/login-route-guard';
import { StatsChartComponent } from 'src/app/reports/case-stats-chart.component';
import { ValueAtRiskComponent } from 'src/app/reports/value-at-risk.component';
import { Stats2Component} from './case-stats2.component';
import { DashboardComponent } from './dashboard.component';

@NgModule({
    imports: [
        CommonModule,
        AccordionModule,
        TableModule,
        FormsModule,
        ToastModule,
        ConfirmDialogModule,
        MessagesModule,
        CalendarModule,
        ProgressSpinnerModule,
        ChartModule,
        RouterModule.forChild([
          { path: 'caselist', component: CaseListComponent, canActivate: [LoginRouteGuard] },
            { path: 'expirationlist', component: ExpirationListComponent, canActivate: [LoginRouteGuard] },
            { path: 'casestats', component: StatsChartComponent, canActivate: [LoginRouteGuard] },
            { path: 'valueatrisk', component: ValueAtRiskComponent, canActivate: [LoginRouteGuard] },
            { path: 'charts', component: Stats2Component, canActivate: [LoginRouteGuard] },
            { path: 'dashboard', component: DashboardComponent, canActivate: [LoginRouteGuard] }
        ]),
    ],
    declarations: [
        CaseListComponent,
        ExpirationListComponent,
        StatsChartComponent,
        ValueAtRiskComponent,
        Stats2Component,
        DashboardComponent,
    ],
    providers: [
        MessageService,
        ConfirmationService,
    ]
})
export class ReportsModule { }
